import ActiveController from "@/controller";

export class aiHtmlPreviewController extends ActiveController {
    constructor($injector,$rootScope,$element,$scope,$timeout) {
        "ngInject";
        super($injector);

        this.$rootScope = $rootScope;
        this.$element = angular.element($element);
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.width = 0;
        this.height = 0;

        $scope.$watch(
            () => this.prWidth,
            () => {
                this.changeSize();
            }
        );

        $scope.$watch(
            () => this.prHeight,
            () => {
                this.changeSize();
            }
        );

        $scope.$watch(
            () => this.index,
            () => {
                this.changeSize();
            }
        );

    }

    $onInit() {
        this.changeSize();
    }

    changeSize() {
        this.width = Math.round(Number(this.prWidth) / Number(this.index)) + "px";
        this.height = Math.round(Number(this.prHeight) / Number(this.index)) + "px";
        if (Number(this.prWidth) > Number(this.prHeight)) {
            this.bleed = {
                width: 1800 / Number(this.index) + "px",
                height: 1200 / Number(this.index) + "px",
                top: 22 / Number(this.index) + "px",
                left: 20 / Number(this.index) + "px",
            };
        } else {
            this.bleed = {
                width: 1200 / Number(this.index) + "px",
                height: 1800 / Number(this.index) + "px",
                top: 20 / Number(this.index) + "px",
                left: 22 / Number(this.index) + "px",
            };
        }
    }
}



// WEBPACK FOOTER //
// ./sources/components/common/ai-html-preview/ai-html-preview.controller.js